import { render, staticRenderFns } from "./cctvBox.vue?vue&type=template&id=03e64797&scoped=true&"
import script from "./cctvBox.vue?vue&type=script&lang=js&"
export * from "./cctvBox.vue?vue&type=script&lang=js&"
import style0 from "./cctvBox.vue?vue&type=style&index=0&id=03e64797&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e64797",
  null
  
)

export default component.exports